import module from "./dc-dropdown";
export default module;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-dropdown/index.js